import {combineReducers} from 'redux'
import userData from './userData/reducer'
import userRates from './accountSettings/userRates/reducer'
import editPanel from './editPanel/reducer'
import createPanel from './createPanel/reducer'
import workStatuses from './accountSettings/workStatuses/reducer'
import authorizationInfo from './authorizationInfo/reducer'

export default combineReducers({
    userData,
    userRates,
    workStatuses,
    editPanel,
    createPanel,
    authorizationInfo,
})


// WEBPACK FOOTER //
// ./web/js/panels/user/reducer.js